import { _ as _sfc_main } from "./VaSeparator.vue_vue_type_script_lang-f07942b5.mjs";
import { openBlock, createElementBlock } from "vue";
import { _ as _export_sfc } from "../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaSeparator_vue_vue_type_style_index_0_lang = "";
const _hoisted_1 = {
  class: "va-separator",
  "aria-hidden": "true"
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1);
}
const VaSeparator = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  VaSeparator as V
};
//# sourceMappingURL=VaSeparator-441efce1.mjs.map
